// The browser's one React Query client, configured in ./query-client. A server render makes its own instead.
import { createQueryClient } from './query-client';

export const queryClient = createQueryClient();
